module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'buttons-panel/in-column' && templateVars.config ?
				templateVars.config :
				{
	"modifier": "in-column",
	"ifEmptyPanel": "remove",
	"animation": {
		"list": {
			"show": {
				"effect": "transition.slideUpIn",
				"duration": 200
			},
			"hide": {
				"effect": "transition.slideDownOut",
				"duration": 200
			}
		},
		"sublist": {
			"show": {
				"effect": "slideDown",
				"duration": 200
			},
			"hide": {
				"effect": "slideUp",
				"duration": 200
			}
		}
	},
	"events": {
		"list": {
			"click": {
				"show": "click touchstart",
				"hide": "click touchstart"
			},
			"hover": {
				"show": "touchstart mouseenter",
				"hide": "mouseover touchstart"
			}
		},
		"sublist": {
			"click": {
				"show": "click touchstart",
				"hide": "click touchstart"
			},
			"hover": {
				"show": "touchstart mouseenter",
				"hide": "mouseover touchstart"
			}
		}
	},
	"hoverablePanel": false,
	"hoverableSublist": false,
	"tools": {
		"panelType": "compact",
		"title": {
			"ru": "Инструменты",
			"en": "Tools"
		},
		"sublistSlideType": "bottom",
		"InMyReport": false,
		"buttonWithText": false,
		"offlineHideButtons": [
			"offline",
			"feedback",
			"share",
			"social"
		],
		"buttonsPanelHideButtons": [
			"siteMap - feedback - compare - offline - questionary - social - ios - android - mobileApp - companyOnMap - siteMap - contacts - xls - glossary - disclaimer - archive - see - applications - zip"
		],
		"hideButtonsOnSystem": [
			"addToReport",
			"delFromReport",
			"printVersion",
			"pdf",
			"share"
		],
		"hideButtonsOnMainPage": [
			"addToReport",
			"delFromReport",
			"feedback",
			"compare",
			"offline",
			"questionary",
			"social",
			"ios",
			"android",
			"mobileApp",
			"companyOnMap",
			"siteMap",
			"contacts",
			"xls",
			"glossary",
			"disclaimer",
			"archive",
			"see",
			"applications",
			"zip",
			"pdf"
		],
		"hideCurrentButtonOnPage": true,
		"showTour": true,
		"sorting": {
			"ru": [
				"myReport",
				"addToReport",
				"delFromReport",
				"pdf",
				"share",
				"history",
				"analysis",
				"printVersion",
				"download",
				"feedback",
				"compare",
				"offline",
				"questionary",
				"social",
				"ios",
				"android",
				"mobileApp",
				"companyOnMap",
				"siteMap",
				"contacts",
				"xls",
				"glossary",
				"disclaimer",
				"archive",
				"see",
				"applications",
				"zip"
			],
			"en": [
				"myReport",
				"addToReport",
				"delFromReport",
				"pdf",
				"share",
				"history",
				"analysis",
				"printVersion",
				"download",
				"feedback",
				"compare",
				"offline",
				"questionary",
				"social",
				"ios",
				"android",
				"mobileApp",
				"companyOnMap",
				"siteMap",
				"contacts",
				"xls",
				"glossary",
				"disclaimer",
				"archive",
				"see",
				"applications",
				"zip"
			]
		},
		"links": [
			{
				"id": "myReport",
				"modifier": "myreport",
				"targetBlank": false,
				"url": "${rootUrl}/my-report",
				"text": {
					"ru": "Мой отчет",
					"en": "My report"
				}
			},
			{
				"id": "addToReport",
				"modifier": "add js-add-page",
				"targetBlank": false,
				"url": "javascript:;",
				"text": {
					"ru": "Добавить в «Мой отчет»",
					"en": "Add to My Report"
				}
			},
			{
				"id": "delFromReport",
				"modifier": "del last-item js-del-page",
				"targetBlank": false,
				"url": "javascript:;",
				"text": {
					"ru": "Удалить из «Моего отчета»",
					"en": "Delete from My Report"
				}
			},
			{
				"id": "printVersion",
				"modifier": "print js-print",
				"targetBlank": true,
				"url": "javascript:;",
				"text": {
					"ru": "Печать страницы",
					"en": "Print version"
				},
				"event": "window.print();"
			},
			{
				"id": "pdf",
				"modifier": "pdf js-get-pdf",
				"targetBlank": true,
				"url": "${pdf}",
				"text": {
					"ru": "Скачать в PDF",
					"en": "PDF version"
				}
			},
			{
				"id": "share",
				"modifier": "share js-share",
				"targetBlank": false,
				"url": "javascript:;",
				"text": {
					"ru": "Поделиться",
					"en": "Share"
				},
				"subList": [
					{
						"id": "shareVkontakte",
						"modifier": "vkontakte",
						"targetBlank": true,
						"url": "http://vkontakte.ru/share.php?url={{pageUrl}}&title={{pageTitle}}&image={{thisSiteUrl}}&description=",
						"text": {
							"ru": "Вконтакте",
							"en": "Vkontakte"
						}
					},
					{
						"id": "shareLinkedin",
						"modifier": "linkedin",
						"targetBlank": true,
						"url": "http://www.linkedin.com/shareArticle?mini=true&url={{pageUrl}}&title={{pageTitle}}&summary=&source={{thisSiteUrl}}",
						"text": {
							"ru": "Linkedin",
							"en": "Linkedin"
						}
					},
					{
						"id": "shareTwitter",
						"modifier": "twitter",
						"targetBlank": true,
						"url": "http://twitter.com/share?text={{pageTitle}}&url={{pageUrl}}",
						"text": {
							"ru": "Twitter",
							"en": "Twitter"
						}
					},
					{
						"id": "shareFacebook",
						"modifier": "facebook",
						"targetBlank": true,
						"url": "https://www.facebook.com/sharer/sharer.php?u={{pageUrl}}&t={{pageTitle}}",
						"text": {
							"ru": "Facebook",
							"en": "Facebook"
						}
					},
					{
						"id": "shareEmail",
						"modifier": "email js-share-form-button",
						"targetBlank": false,
						"url": "",
						"text": {
							"ru": "E-mail",
							"en": "E-mail"
						}
					}
				]
			},
			{
				"id": "history",
				"modifier": "history",
				"targetBlank": false,
				"url": "${rootUrl}/history",
				"text": {
					"ru": "История",
					"en": "Browsing history"
				}
			},
			{
				"id": "download",
				"modifier": "download",
				"targetBlank": false,
				"url": "${rootUrl}/downloads",
				"text": {
					"ru": "Центр загрузок",
					"en": "Download center"
				}
			},
			{
				"id": "analysis",
				"modifier": "analysis",
				"targetBlank": false,
				"url": "${rootUrl}/interactive-analysis",
				"text": {
					"ru": "Интерактивный анализ",
					"en": "Interactive analysis"
				}
			}
		]
	},
	"materials": {
		"panelType": "compact",
		"title": {
			"ru": "Материалы",
			"en": "Materials"
		},
		"slideType": "vertical",
		"buttonWithText": false,
		"offlineHideButtons": [
			"offline"
		],
		"buttonsPanelHideButtons": [],
		"sorting": {
			"ru": [
				"ar",
				"ar2",
				"sustainability",
				"fr",
				"app",
				"journal",
				"offline"
			],
			"en": [
				"ar",
				"ar2",
				"sustainability",
				"fr",
				"app",
				"journal",
				"offline"
			]
		},
		"links": [
			{
				"id": "ar",
				"modifier": "ar",
				"targetBlank": true,
				"url": "${rootUrl}/test_url_static/",
				"text": {
					"ru": "Годовой Отчет 2012",
					"en": "Annual Report 2012"
				}
			},
			{
				"id": "ar2",
				"modifier": "ar",
				"targetBlank": true,
				"url": "${rootUrl}/test_url_static/",
				"text": {
					"ru": "Годовой Отчет 2013",
					"en": "Annual Report 2013"
				}
			},
			{
				"id": "sustainability",
				"modifier": "sustainability",
				"targetBlank": true,
				"url": "${rootUrl}/test_url_static/",
				"text": {
					"ru": "Отчет об устройчивом развитии",
					"en": "Sustainability Report"
				}
			},
			{
				"id": "fr",
				"modifier": "fr",
				"targetBlank": true,
				"url": "${rootUrl}/test_url_static/",
				"text": {
					"ru": "Финансовый Отчет 2012",
					"en": "Financial Report 2012"
				}
			},
			{
				"id": "app",
				"modifier": "app",
				"targetBlank": true,
				"url": "${rootUrl}/test_url_static/",
				"text": {
					"ru": "Приложения",
					"en": "Applications"
				}
			},
			{
				"id": "journal",
				"modifier": "journal",
				"targetBlank": true,
				"url": "${rootUrl}/test_url_static/",
				"text": {
					"ru": "Корпоративный журнал",
					"en": "Corporate journal"
				}
			},
			{
				"id": "offline",
				"modifier": "offline",
				"targetBlank": true,
				"url": "${rootUrl}/test_url_static/",
				"text": {
					"ru": "Off-line версия",
					"en": "Off-line version"
				}
			}
		]
	},
	"download-pdf": {
		"panelType": "compact",
		"title": {
			"ru": null,
			"en": null
		},
		"slideType": "vertical",
		"buttonWithText": true,
		"offlineHideButtons": [],
		"buttonsPanelHideButtons": [],
		"sorting": {
			"ru": [
				"pdfPages",
				"pdfSpreads"
			],
			"en": [
				"pdfPages",
				"pdfSpreads"
			]
		},
		"links": [
			{
				"id": "pdfPages",
				"modifier": "pdf-pages",
				"targetBlank": true,
				"url": "/download/full-reports/${site}_${lang}_annual-report_pages_moex_2019.pdf",
				"text": {
					"ru": "Постранично",
					"en": "Page by page"
				},
				"trackerParams": {
					"en": {
						"type": "click",
						"url": "en_buttons-panel-download-pdf_download-pdf-pages"
					},
					"ru": {
						"type": "click",
						"url": "ru_buttons-panel-download-pdf_download-pdf-pages"
					}
				}
			},
			{
				"id": "pdf-spreads",
				"modifier": "pdf-spreads",
				"targetBlank": true,
				"url": "/download/full-reports/${site}_${lang}_annual-report_spreads_moex_2019.pdf",
				"text": {
					"ru": "Разворотами",
					"en": "Spreads"
				},
				"trackerParams": {
					"en": {
						"type": "click",
						"url": "en_buttons-panel-download-pdf_download-pdf-spreads"
					},
					"ru": {
						"type": "click",
						"url": "ru_buttons-panel-download-pdf_download-pdf-spreads"
					}
				}
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/buttons-panel/.variant/in-column/config.yaml
// module id = 93
// module chunks = 0